// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `preview-banner .preview-banner {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--tertiary-color);
  color: var(--motes-white);
  max-height: 0;
  transition: 0.3s;
  overflow: hidden;
}
preview-banner .preview-banner.show {
  padding: var(--large-spacing);
  padding-top: max(var(--large-spacing), var(--header-height));
  max-height: 200px;
  box-sizing: border-box;
}
preview-banner .preview-banner.gold {
  color: var(--motes-black);
  background: var(--upload-background-gradient);
  justify-content: space-between;
}
preview-banner .preview-banner p {
  font-weight: bold;
  margin: 0;
}
preview-banner .preview-banner a {
  margin-left: var(--small-spacing);
}
preview-banner .preview-banner img {
  margin-top: 5px;
  height: 15px;
  object-fit: contain;
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/preview-banner/preview-banner.component.scss"],"names":[],"mappings":"AAEI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uCAAA;EACA,yBAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;AADR;AAIQ;EACI,6BAAA;EACA,4DAAA;EACA,iBAAA;EACA,sBAAA;AAFZ;AAKQ;EACI,yBAAA;EACA,6CAAA;EACA,8BAAA;AAHZ;AAMQ;EACI,iBAAA;EACA,SAAA;AAJZ;AAOQ;EACI,iCAAA;AALZ;AAQQ;EACI,eAAA;EACA,YAAA;EACA,mBAAA;AANZ","sourcesContent":["preview-banner {\n\n    .preview-banner {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        background-color: var(--tertiary-color);\n        color: var(--motes-white);\n        max-height: 0;\n        transition: 0.3s;\n        overflow: hidden;\n\n\n        &.show {\n            padding: var(--large-spacing);\n            padding-top: max(var(--large-spacing), var(--header-height));\n            max-height: 200px;\n            box-sizing: border-box;\n        }\n\n        &.gold {\n            color: var(--motes-black);\n            background: var(--upload-background-gradient);\n            justify-content: space-between;\n        }\n\n        p {\n            font-weight: bold;\n            margin: 0;\n        }\n\n        a {\n            margin-left: var(--small-spacing);\n        }\n\n        img {\n            margin-top: 5px;\n            height: 15px;\n            object-fit: contain;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
